import { request } from 'utils/axios'; 

const ENDPOINT = 'activities';

export const list = (type = '') => request('get', `${ENDPOINT}?${type ? `type=${type}` : ''}`);
